
























































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import TaxObligationDTO from "@/dto/tax/TaxObligationDTO";
import { Period } from "@/constants/DateTimeConstants";
import { getTaxReportFormLabel } from "@/constants/TaxReportForm";
import { getTaxObligationLiabilityTypeLabel } from "@/constants/TaxObligationLiabilityType";
import TaxObligationPayload from "@/dto/tax/TaxObligationPayload";
import TaxObligationCommentPayload from "@/dto/tax/TaxObligationCommentPayload";
import TaxObligationService from "@/services/TaxObligationService";
import PortalTextarea from "@/components/common/PortalTextarea.vue";
import Application from "@/state/Application";
import { processError } from "@/utils/ComponentUtils";
import moment from "moment";
import { CounterpartyType } from "@/constants/CounterpartyType";
import { YEARS } from "@/constants/DateTimeConstants";
import SelectOption from "@/components/common/SelectOption";
import { TaxObligationStatus } from "@/constants/TaxObligationStatus";
import SublimeEmployeeDTO from "@/dto/sublime/employee/SublimeEmployeeDTO";
import AddLedgerRecordModal from "@/components/admin/tax/AddLedgerRecordModal.vue";
import AddReconciliationRecordModal from "@/components/admin/tax/AddReconciliationRecordModal.vue";
import AddTaxPaymentModal from "@/components/admin/tax/AddTaxPaymentModal.vue";
import EditTaxPaymentModal from "@/components/admin/tax/EditTaxPaymentModal.vue";
import AddTaxObligationDocumentModal from "@/components/admin/tax/AddTaxObligationDocumentModal.vue";
import EditTaxObligationModal from "@/components/admin/tax/EditTaxObligationModal.vue";
import DeleteConfirmation from "@/components/payroll/business/DeleteConfirmation.vue";

@Component({
  components: {
    AddLedgerRecordModal,
    AddReconciliationRecordModal,
    AddTaxPaymentModal,
    EditTaxPaymentModal,
    AddTaxObligationDocumentModal,
    EditTaxObligationModal,
    DeleteConfirmation,
    PortalTextarea
  }
})
export default class TaxObligation extends Vue {
  
  taxObligation: TaxObligationDTO | null = null;
  assignee: SublimeEmployeeDTO | null = null;
  commentPayload: TaxObligationCommentPayload = new TaxObligationCommentPayload();
  highlightedRecordId: number | null = null;

  get id(): number {
    return Number.parseInt(this.$route.params.id);
  }

  get sortedComments() {
    if (!this.taxObligation || !this.taxObligation.comments) return [];
    return [...this.taxObligation.comments].sort((a, b) => 
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
  }

  get sortedLedger() {
    if (!this.taxObligation || !this.taxObligation.ledger) return [];
    return [...this.taxObligation.ledger].sort((a, b) => a.order - b.order);
  }

  get latestReconciliation() {
    if (!this.taxObligation || !this.taxObligation.reconciliationRecords || this.taxObligation.reconciliationRecords.length === 0) {
      return null;
    }
    return [...this.taxObligation.reconciliationRecords].sort((a, b) => {
      return new Date(b.verificationDate).getTime() - new Date(a.verificationDate).getTime();
    })[0];
  }

  mounted(): void {
    this.loadEvent();
  }

  loadEvent(): void {
    Application.startLoading();
    TaxObligationService.getTaxObligation(this.id).then(
      res => {
        this.taxObligation = res.data;
        
        if (this.taxObligation.assigneeId) {
          this.assignee = {
            id: this.taxObligation.assigneeId,
            firstName: this.taxObligation.assigneeName ? this.taxObligation.assigneeName.split(' ')[0] : '',
            lastName: this.taxObligation.assigneeName && this.taxObligation.assigneeName.split(' ')[1] ? this.taxObligation.assigneeName.split(' ').slice(1).join(' ') : ''
          } as any;
        } else {
          this.assignee = null;
        }

        Application.stopLoading();
      },
      err => processError(err, this)
    );
  }

  public onAssigneeSelected(employee: SublimeEmployeeDTO | null): void {
    // Left for potential future use or just cleanup if truly unneeded. 
    // Since it was in the template and we removed the template part, 
    // we can remove the logic that updates 'form' which is now gone.
    this.assignee = employee;
  }

  public getTaxReportFormLabel(type: any): string {
    return getTaxReportFormLabel(type);
  }

  public getTaxObligationLiabilityTypeLabel(type: any): string {
    return getTaxObligationLiabilityTypeLabel(type);
  }

  public getPaymentStatusClass(status: string): string {
    switch (status) {
      case 'SETTLED':
        return 'badge-success';
      case 'DECLINED':
        return 'badge-danger';
      case 'PENDING':
        return 'badge-warning';
      case 'DRAFT':
        return 'badge-secondary';
      default:
        return 'badge-info';
    }
  }
  
  public getFullPeriod(e: TaxObligationDTO): string {
    if(!e.year){
      return '-';
    } else if ((!e.period || e.period === Period.FULL_YEAR || e.period === Period.FISCAL_YEAR) && !!e.year){
      return e.year.toString();
    } else {
      return this.$t('period.enum.' + e.period) + ' ' + e.year;
    }
  }

  get yearOptions() {
    return YEARS.map(year => SelectOption.builder().title(`${year}`).value(year).build());
  }

  get statusClass(): string {
    if (!this.taxObligation) return '';
    const status = this.taxObligation.status as any;
    switch (status) {
      case 'COMPLETED':
        return 'badge-success';
      case 'OVERDUE':
        return 'badge-danger';
      case 'DUE_SOON':
        return 'badge-warning';
      case 'SCHEDULED':
        return 'badge-info';
      default:
        return 'badge-secondary';
    }
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return "-";
    return moment(dateStr).format('MM-DD-YYYY');
  }

  formatAmount(cents: number): string {
    return '$' + (cents / 100).toFixed(2);
  }

  formatDateTime(dateStr: string): string {
    if (!dateStr) return "-";
    return moment(dateStr).format('MM-DD-YYYY HH:mm');
  }

  addComment(): void {
    if (!this.commentPayload.comment.trim()) return;
    
    Application.startLoading();
    TaxObligationService.addComment(this.id, this.commentPayload).then(
      res => {
        Application.stopLoading();
        this.commentPayload = new TaxObligationCommentPayload();
        this.loadEvent();
      },
      err => processError(err, this)
    );
  }

  openAddLedgerRecordModal(): void {
    this.$modal.show('add-ledger-record-modal', {
      taxObligationId: this.id,
      ledger: this.taxObligation?.ledger || []
    });
  }

  openAddReconciliationRecordModal(): void {
    this.$modal.show('add-reconciliation-record-modal', { taxObligationId: this.id });
  }

  openAddTaxPaymentModal(): void {
    this.$modal.show('add-tax-payment-modal', { 
      taxObligationId: this.id,
      ledger: this.taxObligation?.ledger || []
    });
  }

  openEditPaymentModal(item: any): void {
    this.$modal.show('edit-tax-payment-modal', {
      taxObligationId: this.id,
      payment: item,
      ledger: this.taxObligation?.ledger || []
    });
  }

  openAddTaxObligationDocumentModal(): void {
    this.$modal.show('add-tax-obligation-document-modal', { taxObligationId: this.id });
  }

  openEditModal(): void {
    this.$modal.show('edit-tax-obligation-modal', { taxObligation: this.taxObligation });
  }

  deleteDocument(documentId: number): void {
    const doc = this.taxObligation?.documents?.find(d => d.id === documentId);
    const targetName = doc ? doc.file.fileName : this.$t('tax_calendar.labels.document') as string;

    this.$modal.show(DeleteConfirmation, {
      targetName: targetName,
      onDelete: () => {
        Application.startLoading();
        TaxObligationService.deleteDocument(this.id, documentId).then(
            res => {
              Application.stopLoading();
              this.loadEvent();
            },
            err => processError(err, this)
        );
      }
    }, {
      height: 'auto',
      width: '400px',
      adaptive: true
    });
  }

  getRelatedRecordLinkText(relatedId: number): string {
    const related = this.taxObligation?.ledger.find(r => r.id === relatedId);
    if (!related) return '';
    const date = this.formatDate(related.createDate);
    return this.$t('tax_calendar.warnings.related_to', { order: related.order, date: date }) as string;
  }

  public getGroupVariantClass(item: any): string {
    if (!item.paymentId || !this.taxObligation || !this.taxObligation.ledger) return "";
    
    const uniquePaymentIds = Array.from(new Set(
      this.taxObligation.ledger
        .map(r => r.paymentId)
        .filter(id => !!id)
    )).sort((a, b) => (a as number) - (b as number));
    
    const index = uniquePaymentIds.indexOf(item.paymentId);
    return index % 2 === 0 ? "group-even" : "group-odd";
  }

  public isFirstInGroup(item: any, index: number): boolean {
    if (!item.paymentId) return false;
    if (index === 0) return true;
    const prevItem = this.sortedLedger[index - 1];
    return prevItem.paymentId !== item.paymentId;
  }
}
